export default __webpack_public_path__ + "static/media/Kooch_desktop.00d2fa15.png";